/**
 *
 * 格式化时间
 * 如：dateFormat(new Date(),"yyyy年MM日dd");
 * dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss");
 * dateFormat(new Date(),"yyyy-MM-dd")      ;等
 * @export
 * @param {Date} date
 * @param {string} fmt
 * @return {*}
 */
export function dateFormat(date: Date, fmt: string) {
  const o: Record<string | number, any> = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (const k in o) if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  return fmt;
}

/**
 *
 *
 * @export
 * @param {(string|number)} val
 * @return {*}  {string}
 */
export function numberFormat(val: string | number): string {
  let str = "";
  const num = Number(val);
  if (num > 99999999) {
    str = Math.floor((num / Math.pow(10, 8)) * 10) / 10 + "亿";
  } else if (num > 9999) {
    str = Math.floor((num / Math.pow(10, 4)) * 10) / 10 + "万";
  }
  return str;
}

/**
 *
 * 对数字number 进行四舍五入，保留deci位小数位
 * @export
 * @param {number} number
 * @param {number} deci 默认为2
 * @return {*}
 */
export function roundNum(number: number, deci = 2) {
  return Math.floor(number * Math.pow(10, deci)) / Math.pow(10, deci);
}

/**
 *
 * 将字符串按固定长度截断并添加尾缀
 * @export
 * @param {string} str
 * @param {number} limitLen
 * @param {string} Abbreviations 默认值为：···
 * @return {*}
 */
export function cutStr(str: string, limitLen: number, Abbreviations: string) {
  if (str) {
    if (isNaN(limitLen)) {
      limitLen = 8;
    }
    if (!Abbreviations) {
      Abbreviations = "···";
    }
    if (str.length > limitLen) {
      str = str.substr(0, limitLen) + Abbreviations;
    }
  }
  return str;
}
// 补0
export function zeroNum(num: number | string, length: number) {
  for (let len = (num + "").length; len < length; len = num.length) {
    num = "0" + num;
  }
  return num;
}
/**
 *
 * 格式化时间
 * 如：dateFormat(new Date(),"yyyy年MM日dd");
 * dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss");
 * dateFormat(new Date(),"yyyy-MM-dd")      ;等
 * @export
 * @param {number} date
 * @return {*}
 */
export function formatSeconds(seconds: number) {
  let theTime = Math.floor(seconds); // 需要转换的时间秒
  let theTime1 = 0; // 分
  let theTime2 = 0; // 小时
  let theTime3 = 0; // 天
  if (theTime > 60) {
    theTime1 = Math.floor(theTime / 60);
    theTime = theTime % 60;
    if (theTime1 > 60) {
      theTime2 = Math.floor(theTime1 / 60);
      theTime1 = theTime1 % 60;
      if (theTime2 > 24) {
        //大于24小时
        theTime3 = Math.floor(theTime2 / 24);
        theTime2 = theTime2 % 24;
      }
    }
  }
  let result = "";
  if (theTime >= 0) {
    result = "" + theTime + "秒";
  }
  if (theTime1 > 0) {
    result = "" + theTime1 + "分" + result;
  }
  if (theTime2 > 0) {
    result = "" + theTime2 + "小时" + result;
  }
  if (theTime3 > 0) {
    result = "" + theTime3 + "天" + result;
  }
  return result;
}

/**
 *
 * 计算两个时间相差多少天、小时、分钟
 * @export
 * @param {number} date
 * @return {*}
 */
export function calculateDiffTime(starTime = "2022-08-19 00:00:00", endTime = "2022-08-20 00:00:00") {
  // 1天的毫秒数
  const dayMillisecond = 24 * 60 * 60 * 1000;
  // 1小时的毫秒数
  const hourMillsecond = 1000 * 60 * 60;
  // 1min的毫秒值
  const minMillsecond = 1000 * 60;
  // 1s的毫秒值
  const secMillsecond = 1000;
  const start = new Date(starTime).getTime();
  const end = new Date(endTime).getTime();
  const diffTotalTimestamp = end - start;
  if (diffTotalTimestamp <= 0) {
    return {
      diffHour: 0,
      diffDay: 0,
      diffMin: 0,
      diffSec: 0,
    };
  }
  let resetMillSec = diffTotalTimestamp;
  const diffDay = Math.floor(resetMillSec / dayMillisecond);
  resetMillSec = diffTotalTimestamp - diffDay * dayMillisecond;
  const diffHour = Math.floor(resetMillSec / hourMillsecond);
  resetMillSec = diffTotalTimestamp - diffDay * dayMillisecond - diffHour * hourMillsecond;
  const diffMin = Math.floor(resetMillSec / minMillsecond);
  resetMillSec = diffTotalTimestamp - diffDay * dayMillisecond - diffHour * hourMillsecond - diffMin * minMillsecond;
  const diffSec = Math.floor(resetMillSec / secMillsecond);
  console.log(diffHour, diffDay, diffMin, diffSec);
  return {
    diffHour,
    diffDay,
    diffMin,
    diffSec,
  };
}

/**
 *
 * 计算时间
 * @export
 * @param {string} time
 * @return {*}
 */
export function transferStringTime(time: String) {
  return new Date(time.replace(/-/g, "/")).getTime();
}
/**
 *
 * 计算时间
 * @export
 * @param {string} time
 * @return {*}
 */
export function transferStringTime0000(time: string | number) {
  if (typeof time == "string") {
    return new Date(new Date(time.replace(/-/g, "/")).setHours(0, 0, 0, 0)).getTime();
  } else {
    return new Date(new Date(time).setHours(0, 0, 0, 0)).getTime();
  }
}
